/**
 * Pure helper that returns the "collapsed" label displayed on a multi-select
 * filter trigger.
 *
 * @param {Array<string|number>|null|undefined} selectedArr
 * @param {Array} options  Flat `[{ id, label }]` OR grouped `[{ key, title, items: [{ id, label }] }]`
 * @param {string} entityName  e.g. `"locations"`
 * @param {string} placeholder  e.g. `"All locations"`
 * @returns {string}
 */
function formatFilterLabel(selectedArr, options, entityName, placeholder) {
	const arr = Array.isArray(selectedArr) ? selectedArr : [];

	if (arr.length === 0) return placeholder;
	if (arr.length >= 2) return `Multiple ${entityName} are selected`;

	const selectedId = String(arr[0]);
	const flat = flattenOptions(options);
	const found = flat.find(opt => opt && String(opt.id) === selectedId);
	return found ? found.label : placeholder;
}

function flattenOptions(options) {
	if (!Array.isArray(options)) return [];
	if (options.length > 0 && options[0] && Array.isArray(options[0].items)) {
		return options.flatMap(g => g.items || []);
	}
	return options;
}

export default formatFilterLabel;
export { flattenOptions };
